export default __webpack_public_path__ + "static/summer_containers102-6df78d6465b508eacb7de6f37f4cbd28.webp";